// extracted by mini-css-extract-plugin
export default {"section":"inicio-section_section__wMuA3","title":"inicio-section_title__tcDwi"};